import React from "react";
import CustomModalV1 from "components/custom-modal/CustomModalV1";
import ButtonV1 from "components/button/Button";
import { AlertCircleIconV1 } from "images/image-component";
import "./warning-modal.css";

interface Props {
  isOpen: boolean;
  message: string;
  handleClose: () => void;
  title?: string;
}

// Neither an error nor a success: nothing is broken and nothing is done. Used
// for states the merchant is waiting on rather than acting on — hence no
// call-to-action beyond dismissing it.
function WarningModal({
  isOpen,
  message,
  handleClose,
  title = "Action pending",
}: Props) {
  return (
    <CustomModalV1 isOpen={isOpen} handleClose={handleClose}>
      <div className="v1-warning-modal">
        <div className="v1-warning-icon">
          <AlertCircleIconV1 />
        </div>

        <h3 className="v1-warning-title">{title}</h3>
        <p className="v1-warning-msg">{message}</p>

        <div className="v1-warning-actions">
          <ButtonV1 variant="subtle" onClick={handleClose}>
            Close
          </ButtonV1>
        </div>
      </div>
    </CustomModalV1>
  );
}

export default WarningModal;
